import { render } from "./NewProductModal.vue?vue&type=template&id=2b65c3ee"
import script from "./NewProductModal.vue?vue&type=script&lang=js"
export * from "./NewProductModal.vue?vue&type=script&lang=js"

import "./NewProductModal.vue?vue&type=style&index=0&id=2b65c3ee&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__